import { create } from 'zustand';

interface MenuContext {
    /**
     * 금융인증서(생체), 디지털인증서 서명 생략 여부
     */
    fidoSignSkipYn?: string;
    /**
     * MOTP 로그인 고객 서명 생략 여부
     */
    motpSignSkipYn?: string;
    /**
     * 전자서명 실행중 여부
     */
    isRunningSign: boolean;
    /**
     * 보안매체 스킵여부
     */
    tokensSkipYn?: string;
}

/**
 * 메뉴 Context Store state
 */
interface MenuContextStoreState {
    menuContext: MenuContext;

    setMenuContext: (menuContext: Partial<MenuContext>) => void;

    getMenuContext: () => MenuContext;

    clearMenuContext: () => void;
}

/**
 * 메뉴 Context Store
 */
const useMenuContextStore = create<MenuContextStoreState>((set, get) => ({
    menuContext: {
        isRunningSign: false,
    },

    setMenuContext: (menuContext: Partial<MenuContext>) => {
        set({
            menuContext: {
                ...get().menuContext,
                ...menuContext,
            },
        });
    },

    getMenuContext: () => {
        return get().menuContext;
    },

    clearMenuContext: () => {
        set({});
    },
}));

export { useMenuContextStore };
